import commonEn from './locales/en/common.json';
import inventoryEn from './locales/en/inventory.json';
import loginEn from './locales/en/login.json';
import mapEn from './locales/en/map.json';
import adminEn from './locales/en/admin.json';
import mediaImportEn from './locales/en/mediaImport.json';
import offersEn from './locales/en/offers.json';
import reservationsEn from './locales/en/reservations.json';
import clientsEn from './locales/en/clients.json';
import suppliersEn from './locales/en/suppliers.json';
import availabilityImportEn from './locales/en/availabilityImport.json';
import commonPl from './locales/pl/common.json';
import inventoryPl from './locales/pl/inventory.json';
import loginPl from './locales/pl/login.json';
import mapPl from './locales/pl/map.json';
import adminPl from './locales/pl/admin.json';
import mediaImportPl from './locales/pl/mediaImport.json';
import offersPl from './locales/pl/offers.json';
import reservationsPl from './locales/pl/reservations.json';
import clientsPl from './locales/pl/clients.json';
import suppliersPl from './locales/pl/suppliers.json';
import availabilityImportPl from './locales/pl/availabilityImport.json';

export const screenNamespaces = [
  'common',
  'inventory',
  'login',
  'map',
  'admin',
  'mediaImport',
  'offers',
  'reservations',
  'clients',
  'suppliers',
  'availabilityImport',
] as const;

export const screenResources = {
  en: {
    common: commonEn,
    inventory: inventoryEn,
    login: loginEn,
    map: mapEn,
    admin: adminEn,
    mediaImport: mediaImportEn,
    offers: offersEn,
    reservations: reservationsEn,
    clients: clientsEn,
    suppliers: suppliersEn,
    availabilityImport: availabilityImportEn,
  },
  pl: {
    common: commonPl,
    inventory: inventoryPl,
    login: loginPl,
    map: mapPl,
    admin: adminPl,
    mediaImport: mediaImportPl,
    offers: offersPl,
    reservations: reservationsPl,
    clients: clientsPl,
    suppliers: suppliersPl,
    availabilityImport: availabilityImportPl,
  },
};
